module.exports = __webpack_public_path__ + "static/img/0542_4.c6ce5ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/0542_4.jpg
// module id = hH0c
// module chunks = 1